import script from "./AddOrEditUser.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOrEditUser.vue?vue&type=script&setup=true&lang=js"

import "./AddOrEditUser.vue?vue&type=style&index=0&id=1e3a9daa&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e3a9daa"]])

export default __exports__